/**
 * useBrandSettings — US-37.2
 *
 * React Query hooks for brand settings (GET/PUT).
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { coreApiClient } from '@/api/core-client';
import type { BrandSettingsResponse, UpdateBrandSettingsDto } from '@bstock/shared';

const brandSettingsKey = ['brand-settings'] as const;

// ---------------------------------------------------------------------------
// GET
// ---------------------------------------------------------------------------

export function useBrandSettings() {
  return useQuery({
    queryKey: brandSettingsKey,
    queryFn: () =>
      coreApiClient
        .get<{ data: BrandSettingsResponse }>('/brands/settings')
        .then((r) => r.data.data),
  });
}

// ---------------------------------------------------------------------------
// PUT
// ---------------------------------------------------------------------------

export function useUpdateBrandSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateBrandSettingsDto) =>
      coreApiClient
        .put<{ data: BrandSettingsResponse }>('/brands/settings', data)
        .then((r) => r.data.data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: brandSettingsKey });
      toast.success('Parametres mis a jour');
    },
    onError: () => toast.error('Erreur lors de la mise a jour'),
  });
}

